import { useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Icon,
  Item,
  Listbox,
} from "@icg360/design-system";

import { useNavItems } from "hooks/useNavItems";

import styles from "./mobile-nav-menu.module.scss";

type MobileNavMenuProps = {
  onClose: () => void;
};

export const MobileNavMenu = ({
  onClose,
}: MobileNavMenuProps) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const navItems = useNavItems();

  const onSelectionChange = useCallback(
    (selection: Set<string>) => {
      onClose();
      const path = selection.keys().next().value;
      navigate(path);
    },
    [navigate, onClose]
  );

  return (
    <div className={styles.wrapper}>
      <div>
        <Listbox
          items={navItems}
          className={styles.navBoxDS}
          selectedKeys={new Set([pathname])}
          selectionMode="single"
          onSelectionChange={onSelectionChange}
          aria-label="main navigation"
        >
          {({ to, title, iconName }) => (
            <Item key={to} textValue={title.toLowerCase()}>
              <div className={styles.navItem}>
                <Icon name={iconName} />
                {title}
              </div>
            </Item>
          )}
        </Listbox>
      </div>
    </div>
  );
};
